import { Download, ExternalLink, ShieldCheck } from 'lucide-react'
import { getRecorderDownloadInfo } from '../lib/prerelease'

export function RecorderDownloadSection() {
  const recorder = getRecorderDownloadInfo()

  return (
    <section id="recorder-download" className="bg-white rounded-2xl border border-gray-200 p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <Download className="w-4 h-4 text-gray-500" />
            <h2 className="text-sm font-semibold text-gray-700">Recorder アプリ</h2>
            <span className="rounded-full bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-700">
              v{recorder.version}
            </span>
          </div>
          <p className="mt-2 text-xs leading-relaxed text-gray-500">
            LINE通話を録音する Mac 用アプリです。プレリリースでは、Webからライバーを選んで
            Recorderを起動し、録音・文字起こし・要約を通話履歴へ反映します。
          </p>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:items-end">
          <a
            href={recorder.downloadUrl}
            className="inline-flex items-center justify-center gap-1.5 rounded-lg bg-gray-900 px-3 py-2 text-sm font-medium text-white hover:bg-gray-800"
          >
            <Download className="w-4 h-4" />
            DMGをダウンロード
          </a>
          <a
            href={recorder.releaseUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-1 text-xs font-medium text-gray-500 hover:text-gray-700"
          >
            GitHub Releases
            <ExternalLink className="w-3 h-3" />
          </a>
        </div>
      </div>

      <ol className="mt-5 grid gap-3 sm:grid-cols-2">
        {INSTALL_STEPS.map((step) => (
          <li key={step.title} className="rounded-xl border border-gray-100 bg-gray-50 px-3 py-3">
            <div className="flex items-start gap-2">
              <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" />
              <div>
                <p className="text-xs font-semibold text-gray-700">{step.title}</p>
                <p className="mt-1 text-[11px] leading-relaxed text-gray-500">{step.body}</p>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}

const INSTALL_STEPS = [
  {
    title: '1. DMGを開いてApplicationsへ入れる',
    body: 'ダウンロードしたDMGを開き、LogManeRecorder.app を Applications フォルダへドラッグします。'
  },
  {
    title: '2. 初回は右クリックで開く',
    body: '署名なしビルドのため、初回だけ Applications の LogManeRecorder.app を右クリックして「開く」を選びます。'
  },
  {
    title: '3. トークンを貼り付ける',
    body: '下の Recorder Helper トークンを発行してコピーし、Recorder の初回画面に貼り付けます。'
  },
  {
    title: '4. 権限を許可する',
    body: '録音開始時に、マイクと画面収録/システムオーディオ録音の権限を許可します。'
  }
]
